import React, { useCallback, useMemo, useState } from "react";

export type PickupAssignmentMapSyncValue = {
  focusStopId: string | null;
  focusStopVersion: number;
  requestFocusStop: (stopId: string) => void;
  focusDriverDroppableId: string | null;
  focusDriverVersion: number;
  requestFocusDriver: (droppableId: string) => void;
  /** Unassigned static-route droppable id, or null when focus leaves unassigned map picks. */
  focusRouteDroppableId: string | null;
  focusRouteVersion: number;
  requestFocusRoute: (droppableId: string | null) => void;
};

export function usePickupAssignmentMapSyncState(): PickupAssignmentMapSyncValue {
  const [focusStopId, setFocusStopId] = useState<string | null>(null);
  const [focusStopVersion, setFocusStopVersion] = useState(0);
  const [focusDriverDroppableId, setFocusDriverDroppableId] = useState<string | null>(null);
  const [focusDriverVersion, setFocusDriverVersion] = useState(0);
  const [focusRouteDroppableId, setFocusRouteDroppableId] = useState<string | null>(null);
  const [focusRouteVersion, setFocusRouteVersion] = useState(0);

  const requestFocusStop = useCallback((stopId: string) => {
    setFocusStopId(stopId);
    setFocusStopVersion((v) => v + 1);
  }, []);

  const requestFocusDriver = useCallback((droppableId: string) => {
    setFocusDriverDroppableId(droppableId);
    setFocusDriverVersion((v) => v + 1);
    setFocusRouteDroppableId(null);
  }, []);

  const requestFocusRoute = useCallback((droppableId: string | null) => {
    setFocusRouteDroppableId(droppableId);
    setFocusRouteVersion((v) => v + 1);
  }, []);

  return useMemo(
    () => ({
      focusStopId,
      focusStopVersion,
      requestFocusStop,
      focusDriverDroppableId,
      focusDriverVersion,
      requestFocusDriver,
      focusRouteDroppableId,
      focusRouteVersion,
      requestFocusRoute,
    }),
    [
      focusStopId,
      focusStopVersion,
      requestFocusStop,
      focusDriverDroppableId,
      focusDriverVersion,
      requestFocusDriver,
      focusRouteDroppableId,
      focusRouteVersion,
      requestFocusRoute,
    ]
  );
}

export const PickupAssignmentMapSyncContext = React.createContext<PickupAssignmentMapSyncValue | null>(null);
